import { render, staticRenderFns } from "./TaskStatusChangedActivity.vue?vue&type=template&id=5a1fbe84"
import script from "./TaskStatusChangedActivity.vue?vue&type=script&lang=js"
export * from "./TaskStatusChangedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports